export type HeroVariant = 'buses' | 'day' | 'constellation' | 'video';

export const HERO_VARIANTS: Array<[HeroVariant, string]> = [
  ['buses', 'Buses'],
  ['day', "Today's light"],
  ['constellation', 'Degree path'],
  ['video', 'Flyover video'],
];

/** Where the flyover footage lives (see public/landing/hero/README.md). */
export const HERO_VIDEO_DITHERED = '/landing/hero/campus-flyover-dithered.mp4';
export const HERO_VIDEO_RAW = '/landing/hero/campus-flyover.mp4';

export type HeroVideoKind = 'dithered' | 'raw' | null;

let probe: Promise<HeroVideoKind> | null = null;

/** Checks (once) which flyover file exists. A pre-dithered clip wins over the raw one. */
export function probeHeroVideo(): Promise<HeroVideoKind> {
  if (!probe) {
    const exists = (url: string) => fetch(url, { method: 'HEAD', signal: AbortSignal.timeout(1500) })
      .then((res) => res.ok && (res.headers.get('content-type') ?? '').startsWith('video'))
      .catch(() => false);
    probe = exists(HERO_VIDEO_DITHERED).then(async (ok) => (ok ? 'dithered' : (await exists(HERO_VIDEO_RAW)) ? 'raw' : null));
  }
  return probe;
}

export const isHeroVariant = (v: string | null): v is HeroVariant => HERO_VARIANTS.some(([id]) => id === v);
